import React from "react";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import { Api, getParam, useAuthProvider, registerAdapter, Loader } from "@cloudpremise/portal_core";
import { useNavigate } from "react-router-dom";
import { LoginWithLinkState } from "../types";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

// @mui material components
import Grid from "@mui/material/Grid";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    jsforce: any,
    registerAF: any
}

const Signup = (props) => {
    const [ authorized ] = useAuthProvider();
    const defaultState = {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        communityNickname: "",
        startUrl: "/",
        loading: false,
        errorMessage: null
    };

    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    const navigate = useNavigate();
    React.useEffect(() => {
        if(authorized){
            return navigate("/home", { replace: true });
        }
    });
    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function onSubmit(e){
        e.preventDefault();
        if(!isFormValid()){
            return;
        }
        localStorage.removeItem("reactforce_logout");
        const { firstName, lastName, email, password, confirmPassword, communityNickname } = state;
        registerAdapter(firstName, lastName, email, password, confirmPassword, communityNickname, (data) => {
            if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                //Apex function available through visual force page
                window.registerAF(firstName, lastName, email, password, confirmPassword, communityNickname);
            }else{
                let message = 'User already exists.';
                if(typeof(data) === "object" && data.hasOwnProperty("result")){
                    message = data.result;
                }
                setState({
                    ...state,
                    loading: true,
                    errorMessage: message
                });
                console.log("Signup Failed");
            }
        });
        setState({
            ...state,
            loading: true,
            errorMessage: null
        });
    }
    function isFormValid(){
        const { firstName, lastName, email, password, confirmPassword, communityNickname } = state;
        if(firstName.length > 0 && lastName.length > 0 && email.length > 0 && communityNickname.length > 0 && password.length && confirmPassword === password){
            return true;
        }
        return false;
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={7} lg={5} py={{ xs: 0, sm: 2 }} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <MDBox
                                    variant="contained"
                                    bgColor="transparent"
                                    borderRadius="sm"
                                    coloredShadow="none"
                                    p={2}
                                    textAlign="left"
                                >
                                    <h3 style={{marginBottom: "15px"}}>Signup</h3>
                                    <div>
                                        <MDBox mb={2}>
                                            <MDInput
                                                name="firstName"
                                                type="text"
                                                label="First Name"
                                                fullWidth
                                                value={state.firstName}
                                                onChange={(e) => handleChange(e, "firstName")}
                                                required
                                            />
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput
                                                name="lastName"
                                                type="text"
                                                label="Last Name"
                                                fullWidth
                                                value={state.lastName}
                                                onChange={(e) => handleChange(e, "lastName")}
                                                required
                                            />
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput
                                                name="communityNickname"
                                                type="text"
                                                label="Nickname"
                                                fullWidth
                                                value={state.communityNickname}
                                                onChange={(e) => handleChange(e, "communityNickname")}
                                                required
                                            />
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput
                                                name="email"
                                                type="email"
                                                label="Email"
                                                fullWidth
                                                value={state.email}
                                                onChange={(e) => handleChange(e, "email")}
                                                required
                                            />
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput
                                                name="password"
                                                type="password"
                                                label="Password"
                                                fullWidth
                                                value={state.password}
                                                onChange={(e) => handleChange(e, "password")}
                                                required
                                            />
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput
                                                name="confirmPassword"
                                                type="password"
                                                label="Confirm Password"
                                                fullWidth
                                                value={state.confirmPassword}
                                                onChange={(e) => handleChange(e, "confirmPassword")}
                                                required
                                            />
                                        </MDBox>
                                        {
                                            state.errorMessage !== null ?
                                                <Stack mb={2}>
                                                    <Alert severity="error">{state.errorMessage}</Alert>
                                                </Stack>
                                            :
                                                null
                                        }
                                        <MDButton variant="gradient" color="info" onClick={(e) => onSubmit(e)} fullWidth>
                                            {
                                                state.loading ?
                                                    <Loader color="white" size={20} />
                                                :
                                                    "Signup"
                                            }
                                        </MDButton>
                                    </div>
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
};

export default Signup;